"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareEmptyLayoutProps = void 0;
var _auth = require("@ori/auth");
var _mapAndValidateBaseUrls = require("../../utils/mapAndValidateBaseUrls");
var _DefaultLayoutFeature = require("../default/DefaultLayoutFeature");
var _internal = require("./internal");
/**
 * The function is used to constructs object with empty layout properties used by `EmptyLayout` component
 * @param props - {@link PrepareEmptyLayoutProps}
 * @returns Object typed as {@link EmptyLayoutPageProps}
 */
const prepareEmptyLayoutProps = ({
  page: {
    cultureSettings,
    developmentInfo,
    environment,
    features,
    language,
    pageMetaData,
    periodCode,
    servicesUrls,
    tenant,
    token,
    useLegacyKendoCulture = false,
    useLegacyTokenService = false,
    requiredServicesUrls = [],
    enableWebVitalsCollection = false,
    enableFavorites = false,
    operationId
  },
  layout
}) => ({
  page: {
    ...(pageMetaData && {
      pageMetaData
    }),
    ...(layout?.defaultTranslations && {
      defaultTranslations: layout.defaultTranslations
    }),
    ...(layout?.translations && {
      translations: layout.translations
    }),
    cultureSettings,
    language,
    customerId: _auth.NOT_LOGGED_IN_USER_ID,
    developmentInfo,
    environment,
    features: [...features.values()],
    isProduction: process.env.NODE_ENV === 'production',
    pageBuiltAt: new Date().toString(),
    pageFeatures: _DefaultLayoutFeature.DefaultLayoutFeature,
    periodCode,
    servicesUrls: (0, _mapAndValidateBaseUrls.mapAndValidateBaseUrls)(servicesUrls, [..._internal.emptyLayoutRequiredServices, ...requiredServicesUrls]),
    tenant,
    token,
    useLegacyKendoCulture,
    useLegacyTokenService,
    enableWebVitalsCollection,
    enableFavorites,
    operationId
  }
});
exports.prepareEmptyLayoutProps = prepareEmptyLayoutProps;
